import React from 'react';
import styled from 'styled-components';

const imageUrl = (step: number) => {
  return require(`../../assets/images/step${step}.png`);
};

const Container = styled.div`
  max-width: 400px;
  margin: 0 auto 30px auto;
  padding: 10px;
`;

export default ({ step, descrption }: { step: number; descrption: string }) => {
  const url = imageUrl(step);
  return (
    <Container>
      <img width="100%" alt="step" src={url} style={{ maxWidth: 306 }} />
      <div style={{ maxWidth: 400, margin: '0 auto' }}>
        <div className="step-description">{descrption}</div>
      </div>
    </Container>
  );
};
